import {Button, Card, Center, Flex, Group, LoadingOverlay, Space, Text} from "@mantine/core";
import React from "react";
import {useTranslation} from "react-i18next";

export default function MobileDetails({endpoint, signalStrengthRenderer, logout, formatToBeaconDate, goBack, isLoading, customerObject}) {
    const { t } = useTranslation();
    return (<div>
        {
            endpoint ? (
                <div>
                    <Flex justify="flex-end">
                        <Button onClick={goBack} size="md"
                                style={{height: "30px", marginTop: "10px", marginBottom: "10px", marginRight: "10px"}}>{t("Go Back")}</Button>
                    </Flex>
                    <Space h="xl"></Space>
                    <Center>
                        <Card shadow="xl" padding="xl" className="card" pl="xl" style={{
                            width: '97%'
                        }}>
                            <Group justify="space-between" mt="md" mb="xs">
                                <Text fw={700} size="lg">{t("Endpoint SN")}: {endpoint.SerialNumber}</Text>
                            </Group>

                            <Text size="sm">
                                <p><b>{t("Encoder SN")}:</b> {endpoint.EncoderSerialNumber}</p>
                                <p><b>{t("Customer Name")}:</b> {Object.keys(customerObject).find(e => customerObject[e] === endpoint.CustomerUuid)}
                                </p>
                                <p><b>{t("Activation Time")}:</b> {formatToBeaconDate(endpoint.ActivationTime)}</p>
                                <p><b>{t("Signal Strength")}:</b> {signalStrengthRenderer(endpoint.NetworkStatus)}</p>
                                <p><b>{t("Endpoint Status")}:</b> {t(endpoint.EndpointStatus)}</p>
                                <p><b>{t("Meter Status")}:</b> {t(endpoint.MeterStatus)}</p>
                                <p><b>{t("last-read")}:</b> {endpoint.LastRead}</p>
                            </Text>
                        </Card>
                    </Center></div>) : (
                <div><Flex justify="flex-end">
                    <Button onClick={goBack} size="md"
                            style={{height: "30px", marginTop: "10px", marginBottom: "10px", marginRight: "10px"}}>{t("Go Back")}</Button>
                </Flex>
                    <Space h="xl"></Space>
                    <Center>
                        <Card shadow="xl" padding="xl" className="card" pl="xl" style={{
                            width: '97%'
                        }}><LoadingOverlay visible={isLoading} zIndex={10} overlayProps={{radius: "sm", blur: 10000}}/>
                            <Group justify="space-between" mt="md" mb="xs">
                                <Text fw={700} size="lg">{t("Endpoint SN")}:</Text>
                            </Group>

                            <Text size="sm">
                                <p><b>{t("Encoder SN")}:</b></p>
                                <p><b>{t("Customer Name")}:</b></p>
                                <p><b>{t("Activation Time")}:</b></p>
                                <p><b>{t("Signal Strength")}:</b>{signalStrengthRenderer(false)}</p>
                                <p><b>{t("Endpoint Status")}:</b></p>
                                <p><b>{t("Meter Status")}:</b></p>
                                <p><b>{t("last-read")}:</b></p>
                            </Text>
                        </Card>
                    </Center></div>)
        }
    </div>)
}